<template>
  <v-container fluid class="pa-4">
    <v-row justify="center">
      <v-col cols="12" md="8" lg="7">
        <v-stepper v-model="step" alt-labels class="customBorderRadius elevation-0 modern-card" style="border: 1px solid #e0e0e0;">
          <v-stepper-header>
            <v-stepper-step :complete="step > 1" step="1" color="primary">
              Basic Info
            </v-stepper-step>
            <v-divider />
            <v-stepper-step :complete="step > 2" step="2" color="primary">
              Features &amp; Media
            </v-stepper-step>
            <v-divider />
            <v-stepper-step :complete="step > 3" step="3" color="primary">
              Layout &amp; Style
            </v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <wizard-step1
                v-model="formData"
                @next="step = 2"
              />
            </v-stepper-content>

            <v-stepper-content step="2">
              <wizard-step2
                v-model="formData"
                @next="step = 3"
                @back="step = 1"
              />
            </v-stepper-content>

            <v-stepper-content step="3">
              <wizard-step3
                v-model="formData"
                @generate="submitPage"
                @back="step = 2"
              />
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>

        <!-- Generation Preloader -->
        <v-dialog v-model="saving" persistent max-width="380">
          <v-card class="pa-6 text-center customBorderRadius" style="overflow: hidden;">
            <div class="generation-bar"></div>
            <div class="my-5">
              <div class="ai-pulse-ring">
                <v-icon size="44" color="primary" class="ai-icon">mdi-creation</v-icon>
              </div>
            </div>
            <div class="text-h6 font-weight-bold mb-1" style="color: #1e293b;">Generating your page…</div>
            <div class="text-body-2" style="color: #64748b;">AI is crafting content & images. This may take a moment.</div>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import WizardStep1 from "@/components/gopagesv2/WizardStep1.vue";
import WizardStep2 from "@/components/gopagesv2/WizardStep2.vue";
import WizardStep3 from "@/components/gopagesv2/WizardStep3.vue";
import fb from "../js/firebase.js";

export default {
  name: "GoPagesV2Wizard",
  components: { WizardStep1, WizardStep2, WizardStep3 },
  data() {
    return {
      step: 1,
      saving: false,

      formData: {
        status: "draft",
        layoutId: "split",
        colorScheme: { name: "Corporate", primary: "#2563eb", secondary: "#1d4ed8", background: "#ffffff", textColor: "#1e293b", textSecondary: "#64748b", font: "Roboto", radius: "4px", isDark: false, preset: "Corporate" },
        pageContent: {},
        formConfig: { fields: ["name", "phone", "email"] },
        legalConfig: { autoGenerate: true },
      },
    };
  },
  computed: {
    ...mapGetters(["ENDPOINT"]),
    isEdit() {
      return !!this.$route.params.id;
    },
  },
  created() {
    if (this.isEdit) {
      this.loadPage(this.$route.params.id);
    } else {
      // Set company info from store
      var companyDetails = this.$store.state.companyDetails;
      this.formData.companyId = companyDetails.id || companyDetails._id;
      this.formData.accountsId = this.$store.state.user.id;
    }
  },
  methods: {
    loadPage(id) {
      this.$http
        .get(`${this.ENDPOINT}/gopages/${id}`)
        .then((res) => {
          this.formData = res.body;
        })
        .catch(() => {
          this.$swal("Error", "Failed to load page", "error");
          this.$router.push({ name: "Go Pages" });
        });
    },
    submitPage() {
      var self = this;
      this.saving = true;

      var url = this.isEdit
        ? `${this.ENDPOINT}/gopages/${this.$route.params.id}`
        : `${this.ENDPOINT}/gopages`;
      var method = this.isEdit ? "put" : "post";

      this.$http[method](url, this.formData)
        .then((res) => {
          var pageId = res.body.id || res.body._id;
          if (this.isEdit) {
            this.saving = false;
            this.$swal("Success", "Page updated!", "success");
            this.$router.push({ name: "GoPagesV2Editor", params: { id: pageId } });
          } else {
            fb.log("gopage_created", { pageId: pageId, businessName: this.formData.businessName });
            fb.log("gopage_ai_generate", { pageId: pageId });
            return this.$http.post(`${this.ENDPOINT}/gopages/${pageId}/generateContent`)
              .then(() => {
                self.saving = false;
                self.$router.push({ name: "GoPagesV2Editor", params: { id: pageId } });
              });
          }
        })
        .catch((err) => {
          self.saving = false;
          var msg = (err.body && err.body.error && err.body.error.message) || "Something went wrong";
          self.$swal("Error", msg, "error");
        });
    },
  },
};
</script>

<style scoped>
.generation-bar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #2563eb, #6d28d9, #f43f5e, #2563eb);
  background-size: 300% 100%;
  animation: shimmer 2s linear infinite;
}
@keyframes shimmer {
  0% { background-position: 100% 0; }
  100% { background-position: -100% 0; }
}

.ai-pulse-ring {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 88px;
  height: 88px;
  border-radius: 50%;
  background: rgba(37, 99, 235, 0.08);
  animation: pulse-ring 2s ease-in-out infinite;
}
@keyframes pulse-ring {
  0%, 100% { box-shadow: 0 0 0 0 rgba(37, 99, 235, 0.2); }
  50% { box-shadow: 0 0 0 20px rgba(37, 99, 235, 0); }
}

.ai-icon {
  animation: spin-slow 4s linear infinite;
}
@keyframes spin-slow {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
